module.exports = __webpack_public_path__ + "img/ee2.57b46d7c.svg";